import * as React from "react";
import MerchantBranchLocation from "../../../../model/merchant/MerchantBranchLocation";
import SelectComponent from "../../../ui/select/SelectComponent";

export default class SelectPreferredMerchantBranchLocation extends SelectComponent<MerchantBranchLocation> {
	//Not used, required abstract method. Filtering of merchant branch locations is handled by backend.
	matchFilter(element: MerchantBranchLocation) {
		return true
	}

	elementToString(element: MerchantBranchLocation): string {
		return element.name;
	}

	elementToId(element: MerchantBranchLocation): string {
		return element.id;
	}
}